/**
 * @file Exemplo
 * jsdoc Board.js ControlLevel.js  Construtor.js ControlGame.js -d ../../documention
 * @author William Luis Alves Ferreira (git:illiamw)
 * @version 2.0.0
 */

import React from "react";

/**
 * @param {Null} Null Null
 * @description Classe geradora da função app
 * @constructor
 */

export default function View_instrucao1(conteudo, acoes) {

  function inserirConteudo(inserir) {
    if (inserir !== null) {
      return (
        <div className="flex-fill w-100  d-flex align-items-end pb-5">
          <div className='col fs-2 fw-bold text-black1'>
            {inserir}

          </div>
        </div>
      );
    }
    else
      return (null)
  }

  function inserirAcoes(inserir) {
    if (inserir !== null) {
      return (
        <div className="flex-fill w-100  text-center  d-flex justify-content-center align-items-start">
          <div className='col h-100 fs-2 fw-bold d-flex justify-content-center align-items-center'>
            {inserir}

          </div>

        </div>
      );
    }
    else
      return (null)
  }

  // ROTEAMENTO - colocar controle de estados da aplicação
  return (

    <div className="col d-flex flex-column align-items-center  text-center w-100 h-100 p-3">

      {inserirConteudo(conteudo)}
      {inserirAcoes(acoes)}

    </div>
  );
}
